import { render, staticRenderFns } from "./BiologicalWarningCapture.vue?vue&type=template&id=a7b433a8&scoped=true"
import script from "./BiologicalWarningCapture.vue?vue&type=script&lang=js"
export * from "./BiologicalWarningCapture.vue?vue&type=script&lang=js"
import style0 from "./BiologicalWarningCapture.vue?vue&type=style&index=0&id=a7b433a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b433a8",
  null
  
)

export default component.exports